import { Box, Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import { IInternalTraining } from '../../../services/api/action-plan/InternalTraining';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';

interface ISummaryTraining {
    data: IInternalTraining
}

export const SummaryTraining = ({data}: ISummaryTraining) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return(
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box>
                <Typography><strong>Informações do Treinamento</strong></Typography>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data treinamento : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_treinamento)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Periodo de referência : </Typography>
                    <Typography>{formatDateWhitoutHour(data.periodo_referencia)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Responsável técnico : </Typography>
                    <Typography>{data.responsavel_tecnico}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>ART : </Typography>
                    <Typography>{data.art}</Typography>
                </Box>
                <Divider/>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '5px', overflowX: 'auto'}} width={'100%'}>
                    <Typography><strong>Participantes</strong></Typography>
                    <Table component={Paper} sx={{borderRadius: '25px', borderColor: theme.palette.primary.contrastText, flex: 1}} variant='elevation'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Profissional</TableCell>
                                <TableCell>Empresa</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.participantes?.map((item, index) => 
                                <TableRow key={index}>
                                    <TableCell>{item.profissional}</TableCell>
                                    <TableCell>{item.empresa}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        </Box>
    );
};